import { render, staticRenderFns } from "./MypageMessageEditor.vue?vue&type=template&id=3b4c5cb6&scoped=true"
import script from "./MypageMessageEditor.vue?vue&type=script&lang=js"
export * from "./MypageMessageEditor.vue?vue&type=script&lang=js"
import style0 from "./MypageMessageEditor.vue?vue&type=style&index=0&id=3b4c5cb6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4c5cb6",
  null
  
)

export default component.exports